"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFieldName = void 0;
const date_1 = require("../formatters/date");
const get_1 = __importDefault(require("lodash-es/get"));
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
function dateFieldName(field, filterField, userPreferences) {
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    const dateModes = (0, get_1.default)(fieldLogic.dateModes, filterField.comparison, fieldLogic.dateModes.default);
    const dateMode = dateModes.find(({ value }) => value === filterField.value.date_mode);
    if (!dateMode) {
        return "";
    }
    let resolvedValue = dateMode.label.toLowerCase();
    if (filterField.value.date_mode_value) {
        if (dateMode.value === "exact_date") {
            const formattedDate = (0, date_1.formatStandardDate)(filterField.value.date_mode_value, userPreferences.locale.value);
            resolvedValue = `${resolvedValue} ${formattedDate}`;
        }
        if (dateMode.value === "date_range") {
            const date = filterField.value.date_mode_value;
            const formattedDate = [
                (0, date_1.formatStandardDate)(date.lower, userPreferences.locale.value),
                (0, date_1.formatStandardDate)(date.upper, userPreferences.locale.value),
            ].join(" - ");
            resolvedValue = `${resolvedValue} ${formattedDate}`;
        }
        if (["next_number_of_days", "past_number_of_days"].includes(dateMode.value)) {
            const date = filterField.value.date_mode_value;
            resolvedValue = `${resolvedValue} ${date}`;
        }
    }
    return resolvedValue;
}
exports.dateFieldName = dateFieldName;
